import {
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
  Control,
  Controller,
  UseFormResetField
} from 'react-hook-form';

export interface UserInfo {
  referenceId: string;
  name: string;
  allocationInfo: {
    activeUnpaidCases: number;
  };
}

export interface IReporteeWithAllocation {
  activeUnpaidCases: number;
  name: string;
  referenceId: string;
  currentLevel: string;
  bucketGroup: string;
}

interface IOptions {
  value: string;
  label: string;
}

interface IReallocationDistribution {
  agentReferenceId: string;
  agentName: string;
  allocatedCases: number;
  totalCases: number;
}

interface IReallocationRequestParam {
  fromAgentName: string;
}

export interface IReallocationHistory {
  referenceId: string;
  ownerReferenceId: string;
  type: string;
  successCount: number;
  failureCount: number;
  startTime: string;
  endTime: string;
  uploadStatus: ReallocationStatus;
  isDetailRow?: boolean;
  toggleState?: boolean;
  jobData: {
    autoAllocationResult: {
      distributionList: IReallocationDistribution[];
    };
    reallocationRequest: IReallocationSubmitPayload;
  };
}

export interface IReallocationSlice {
  reporteesWithAllocation: {
    data: IOptions[];
    selectedAgent: IReporteeWithAllocation | null;
    originalData: IReporteeWithAllocation[];
    loading: boolean;
  };
  activeTeleUsers: {
    data: IOptions[];
    maxCountOfAgents: number;
    loading: boolean;
  };
  isFormSubmitting: boolean;
  reallocationHistory: {
    data: IReallocationHistory[];
    loading: boolean;
    totalElements: number;
    pageNo: number;
  };
  reallocationCaseTypes: string[];
}

export enum ReallocationType {
  SELECTED_AGENTS = 'SELECTED_AGENTS',
  TO_SAME_CYCLE = 'TO_SAME_CYCLE'
}

export enum ReallocationReasons {
  AGENT_RESIGN = 'AGENT_RESIGN',
  AGENT_ABSCONDS = 'AGENT_ABSCONDS',
  AGENT_LONG_LEAVE = 'AGENT_LONG_LEAVE',
  AGENT_TERMINATED = 'AGENT_TERMINATED',
  AGENT_PIP = 'AGENT_PIP',
  OTHERS = 'OTHERS'
}

export enum ReallocationCaseType {
  ALL = 'All',
  DPD_1_TO_30 = 'DPD 1-30 cases',
  BLACKOUT = '30+ Blackout period cases'
}

export interface IReallocationFormValues {
  fromAgentReferenceId: string;
  toAgentReferenceIds: string[];
  toType: ReallocationType;
  reasonType: ReallocationReasons;
  reason: '';
  subReallocationType: ReallocationCaseType;
}

export interface IReallocationSubmitPayload {
  reAllocationType: string;
  reAllocationSubType: string;
  reAllocationReason: string;
  reasonDescription: string;
  sourceAgentReferenceId: string;
  agentCohort: string;
  destinationAgentReferenceIds: string[];
}

export interface IReallocationForm {
  register: UseFormRegister<IReallocationFormValues>;
  setValue: UseFormSetValue<IReallocationFormValues>;
  watch: UseFormWatch<IReallocationFormValues>;
  control: Control<IReallocationFormValues, any>;
  Controller: typeof Controller;
  reallocationType: ReallocationType;
  reasonType: ReallocationReasons;
  toAgentReferenceIds: string[];
  selectedOptions: IOptions[];
  setSelectedOptions: (options: IOptions[]) => void;
  reset: UseFormResetField<IReallocationFormValues>;
}

export enum ReallocationStatus {
  INPROGRESS = 'INPROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INITIATED = 'INITIATED'
}

export interface IReallocationHistoryPayload {
  pageNo: number;
  pageSize: number;
}

export interface IReallocationDetails {
  rowData?: IReallocationHistory;
}

export interface IReallocationHistoryDrawer {
  isDrawerOpen: boolean;
}

export interface IReallocationHeader {
  toggleHistoryDrawer: () => void;
}

export enum ReallocationTypeOptions {
  TELE_RE_ALLOCATION = 'Tele re-allocation'
}
